<dx-box #contactUsPage direction="col" width="100%" height="100%">
    <dxi-item baseSize="auto">
        <h2 [ngClass]="{ 'cc-text-center': isSmallScreen }">Contact Us</h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background cc-contact-us-container">
        <ng-container *ngIf="isInternalUser; then internalUserContactUs; else externalUserContactUs"></ng-container>

        <ng-template #internalUserContactUs>
            <app-internal-user-contact-us></app-internal-user-contact-us>
        </ng-template>

        <ng-template #externalUserContactUs>
            <app-external-user-contact-us></app-external-user-contact-us>
        </ng-template>
    </dxi-item>
</dx-box>
